import { DndContext } from '@dnd-kit/core';
import cx from 'classnames';
import TableRenderer from '../TableRenderer';
import {
  useClozeDragAndDrop,
  useWordBank,
  Dropzone,
  DraggableWord,
  DraggableWordBank,
} from '../DragAndDrop';
import style from './style.scss';
/* eslint-disable react/prop-types */ // TODO: add props

export const ClozeTableDragAndDrop = ({
  blockData,
  blockResponse,
  onResponseChange,
  readOnly,
}) => {
  const { content, withHeadings, options } = blockData;
  const { response_values: responseValues = [] } = blockResponse || {};
  const { remainingWords } = useWordBank(options, responseValues);
  const recordMovement = useClozeDragAndDrop(
    remainingWords,
    responseValues,
    onResponseChange,
    !!'allowMultiple'
  );

  const handleDragEnd = (event) => {
    if (!event.over) {
      return;
    }

    recordMovement(
      event.active.id,
      event.over.id,
      event.active.data.current?.responseFieldIndex
    );
  };

  return (
    <DndContext onDragEnd={handleDragEnd}>
      {(!readOnly || remainingWords.length > 0) && (
        <DraggableWordBank words={remainingWords} disabled={readOnly} />
      )}
      <TableRenderer
        content={content}
        renderResponseField={(responseFieldIndex, isHeading) => {
          const fieldResponses = responseValues[responseFieldIndex] || [];
          const dropzoneKey = `dropzone_${responseFieldIndex}`;
          const droppedKey = `dropped_${responseFieldIndex}`;
          const Component = isHeading ? 'th' : 'td';
          return (
            <Component className={style.tableCell} data-response-cell>
              <Dropzone
                id={dropzoneKey}
                key={dropzoneKey}
                className={cx(style.responseField, {
                  [style.wordDropped]: fieldResponses.length > 0,
                })}
                draggableOverClassName={style.responseFieldDraggableOver}
                as="div"
                disabled={readOnly}
              >
                {fieldResponses.length ? (
                  fieldResponses.map((droppedWord, index) => (
                    <DraggableWord
                      id={`${droppedKey}-${index}`}
                      key={`${droppedKey}-${index}`}
                      data={{
                        responseFieldIndex,
                      }}
                      disabled={readOnly}
                    >
                      {droppedWord}
                    </DraggableWord>
                  ))
                ) : (
                  <>&nbsp;</>
                )}
              </Dropzone>
            </Component>
          );
        }}
        withHeadings={withHeadings}
      />
    </DndContext>
  );
};
